import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Box, CircularProgress, Alert, Container } from '@mui/material';
import { useAuth } from '../context/AuthContext';

/**
 * Admin-only protected route component
 * Redirects to dashboard if user is not admin
 * Redirects to login if user is not authenticated
 */
const AdminRoute: React.FC = () => {
  const { isAuthenticated, isAdmin, isLoading } = useAuth();

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!isAdmin) {
    return (
      <Container maxWidth="sm" sx={{ mt: 8 }}>
        <Alert severity="error">
          Access Denied: You do not have permission to access this page. Admin privileges required.
        </Alert>
      </Container>
    );
  }

  return <Outlet />;
};

export default AdminRoute;
